module.exports = __webpack_public_path__ + "img/communication10.ce5f2cbb.png";